export default __webpack_public_path__ + "static/media/background.b8e1e2dd.png";